<template>
  <div>
    <md-card>
      <md-card-content>
        <md-layout md-gutter>
          <md-layout md-flex="40"></md-layout>
          <md-layout md-flex="60">
            <h2>Hire Model</h2>
            <md-layout md-flex="35"></md-layout>
            <md-layout md-flex="40">
              <md-button
                class="md-raised md-primary md-button-color heght-1px"
                @click="viewClientpage"
              >View Contract Details</md-button>
            </md-layout>
          </md-layout>
        </md-layout>
        <hr class="hr-s">

        <div class="phone-viewport" id="vehicleBooking">
          <md-list>
            <md-list-item
              id="showvehicleBooking"
              class="md-button-color-toggle"
              v-bind:class="{'md-active': isActiveVehicleBooking }"
            >
              <span>Vehicle Booking</span>

              <md-list-expand>
                <md-list>
                  <md-layout md-gutter class="mrgtop-2per">
                    <md-layout md-flex="5"></md-layout>
                    <md-layout md-flex="20">
                      <md-layout md-flex="100">
                        <label>No.Of Trucks</label>
                        <b-form-input :formatter="capitalizeAll"
                          type="number"
                          min="0"
                          id="noOfTrucks"
                          name="noOfTrucks"
                          v-model="Vbooking.noOfTrucks"
                          disabled
                        ></b-form-input>
                      </md-layout>
                      <span class="error" v-if="!Vbooking.noOfTrucks">{{noOfTrucksError}}</span>
                    </md-layout>
                    <md-layout md-flex="5"></md-layout>
                    <md-layout md-flex="20">
                      <md-button
                        style="margin-top:18px"
                        class="md-raised md-primary md-button-color heght-1px"
                        @click="openAddTruckDialog('dialog1')"
                      >Select Truck</md-button>
                      <h3
                        class="error"
                      >{{Vbooking.noOfTrucks != checkItems.length ? error.vehicleSelectError1: ''}}</h3>
                    </md-layout>
                  </md-layout>

                  <div class="box" v-if="this.checkItems.length>0">
                    <div class="box-header">
                      <h3 class="box-title">Vehicle Booking Details</h3>
                    </div>
                    <hr class="hr-s">
                    <!-- /.box-header
                    <span class="error">{{ error.vehicleSelectError.length > 0 ? error.vehicleSelectError: "" }}</span>-->
                    <div class="box-body">
                      <table id="hireModel2" class="table table-bordered table-striped">
                        <thead>
                          <tr>
                            <th>Sr No.</th>
                            <th>Vehicle Number</th>
                            <th>Vehicle Type</th>
                            <th>Driver Name</th>
                            <th>Driver Number</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(obj, index) in checkItems" :key="index">
                            <td>{{index + 1}}</td>
                            <td
                              v-for="(item,index) in obj"
                              :key="index"
                              v-if="index != 'isTruckMasterActive' && index != 'vehicleTruckId'"
                            >{{item}}</td>

                            <!-- <button @click="removeSelectedTruck(obj.vehicleTruckId,index,obj)" > Remove</button>   </td>           -->
                            <td>
                              <md-button
                                class="md-icon-button md-raised md-dense"
                                @click="removeSelectedTruck(obj.vehicleTruckId,index,obj)"
                              >
                                <md-icon>delete_sweep</md-icon>
                              </md-button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <!-- /.box-body -->
                  </div>

                  <md-layout md-gutter>
                    <md-layout md-flex="40"></md-layout>
                    <md-layout md-flex="20">
                      <md-button
                        class="md-raised md-primary md-button-color heght-1px"
                        id="addButtonLoader"
                        @click="addVehicleBooking()"
                      >Submit</md-button>
                      <md-spinner md-indeterminate id="loader" style="display:none"></md-spinner>
                    </md-layout>
                  </md-layout>
                </md-list>
              </md-list-expand>
            </md-list-item>
          </md-list>
        </div>

        <hr class="hr-s">

        <div class="phone-viewport" id="followup" style="display:none">
          <md-list>
            <md-list-item
              id="showvehicleBooking"
              class="md-button-color-toggle"
              v-bind:class="{'md-active': isActiveFollowActivities }"
            >
              <span>FollowUp</span>

              <md-list-expand>
                <md-list>
                  <md-layout md-gutter class="mrgtop-2per">
                    <md-layout md-flex="5"></md-layout>
                    <md-layout md-flex="25">
                      <md-layout md-flex="100">
                        <label>Contract Series</label>
                        <b-form-input :formatter="capitalizeAll" v-model="contractDetailModal.contractSeries" disabled></b-form-input>
                      </md-layout>
                    </md-layout>
                    <md-layout md-flex="5"></md-layout>
                    <md-layout md-flex="25">
                      <md-layout md-flex="100">
                        <label>Contract Type</label>
                        <b-form-input :formatter="capitalizeAll" v-model="contractDetailModal.contractType" disabled></b-form-input>
                      </md-layout>
                    </md-layout>
                    <md-layout md-flex="5"></md-layout>
                    <md-layout md-flex="25">
                      <md-layout md-flex="100">
                        <label>Monthly Charges</label>
                        <b-form-input :formatter="capitalizeAll" v-model="contractDetailModal.monthlyRent" disabled></b-form-input>
                      </md-layout>
                    </md-layout>
                  </md-layout>

                  <md-layout
                    md-gutter
                    class="gutr"
                    v-if="contractDetailModal.contractType!='fuelType'"
                  >
                    <md-layout md-flex="5"></md-layout>
                    <md-layout md-flex="25">
                      <md-layout md-flex="100">
                        <label>Allowed Km</label>
                        <b-form-input :formatter="capitalizeAll" v-model="contractDetailModal.allowedKm" disabled></b-form-input>
                      </md-layout>
                    </md-layout>
                    <md-layout md-flex="5"></md-layout>
                    <md-layout md-flex="25">
                      <md-layout md-flex="100">
                        <label>Over Charges</label>
                        <b-form-input :formatter="capitalizeAll" v-model="contractDetailModal.overcharges" disabled></b-form-input>
                      </md-layout>
                    </md-layout>
                  </md-layout>
                  <hr class="hr-border">
                  <md-layout md-gutter>
                    <md-layout md-flex="40"></md-layout>
                    <md-layout md-flex="20">
                      <md-button
                        class="md-raised md-primary md-button-color heght-1px"
                        @click="openSelectTruckDialog('dialog2')"
                      >New Assignment</md-button>
                    </md-layout>
                  </md-layout>
                  <hr>
                  <h3 v-if="showFollowUpActivity.length>0">FollowUp Details</h3>

                  <div class="box" v-if="showFollowUpActivity.length>0">
                    <div class="box-header">
                      <h3 class="box-title"></h3>
                    </div>
                    <hr class="hr-s">
                    <!-- /.box-header -->
                    <div class="box-body">
                      <table id="hireModel1" class="table table-bordered table-striped">
                        <thead>
                          <tr>
                            <th>Sr.no</th>
                            <th>Truck No</th>
                            <th>From Location</th>
                            <th>To Location</th>
                            <th>Km Covered</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(item,index) in showFollowUpActivity" :key="index">
                            <td>{{index+1}}</td>
                            <td>{{item.regdNo}}</td>
                            <td>{{item.fromLocation}}</td>
                            <td>{{item.toLocation}}</td>
                            <td>{{item.kmCovered}}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <!-- /.box-body -->
                  </div>

                  <md-layout md-gutter class="mrgtop-2per" v-if="showFollowUpActivity.length>0">
                    <md-layout md-flex="40"></md-layout>
                    <md-layout md-flex="20">
                      <!-- <md-button class="md-raised md-primary md-button-color heght-1px " @click="hireSubmit">Submit Invoice  </md-button> -->
                    </md-layout>
                  </md-layout>
                </md-list>
              </md-list-expand>
            </md-list-item>
          </md-list>
        </div>
      </md-card-content>
    </md-card>

    <md-dialog class="HereDialog" md-open-from="#custom" md-close-to="#custom" ref="dialog1">
      <md-dialog-title>
        <span class="error">{{ error.vehicleSelectError.length > 0 ? error.vehicleSelectError: "" }}</span>
      </md-dialog-title>
      <md-dialog-content>
        <div class="box">
          <div class="box-header">
            <h3 class="box-title">Vehicle Booking Details</h3>
          </div>
          <!-- /.box-header -->
          <div class="box-body">
            <table id="hireModel3" class="table table-bordered table-striped">
              <thead>
                <tr>
                  <th>Action</th>
                  <th>Sr No.</th>
                  <th>Vehicle Number</th>
                  <th>Vehicle Type</th>
                  <th>Driver Name</th>
                  <th>Driver Number</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(obj, index) in unCheckItems" :key="index">
                  <td>
                    <md-checkbox
                      @change="checkSelectVehicle(index,obj)"
                      v-model="emptyArray[index]"
                      class="md-primary"
                      :md-value="obj.vehicleTruckId"
                      :name="'vehicle'+(index+1)"
                      :id="'vehicle'+(index+1)"
                    ></md-checkbox>
                  </td>
                  <td>{{index + 1}}</td>
                  <td
                    v-for="(item,index) in obj"
                    :key="index"
                    v-if="index != 'isTruckMasterActive' && index != 'vehicleTruckId'"
                  >{{item}}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- /.box-body -->
        </div>
      </md-dialog-content>

      <md-dialog-actions>
        <md-button :disabled="checkIsDisabled" class="md-primary" @click="onSubmitTable">Ok</md-button>
      </md-dialog-actions>
    </md-dialog>

    <md-dialog class="HereDialog" md-open-from="#custom" md-close-to="#custom" ref="dialog2">
      <md-dialog-content>
        <div class="box">
          <!-- /.box-header -->
          <div class="box-body">
            <md-layout md-gutter class="modal-header-set">
              <md-layout md-flex="40"></md-layout>
              <md-layout md-flex="55">
                <h2 style="margin: 7px;">Follow Up</h2>
              </md-layout>
              <md-layout md-flex="5">
                <md-button
                  class="md-icon-button md-raised md-dense modal-close-btnn"
                  @click="closeModal()"
                >
                  <md-icon>close</md-icon>
                </md-button>
                <!-- <button  class="md-button md-raised md-primary md-button-color md-theme-default heght-1px" >&laquo; Back</button> -->
              </md-layout>
              <hr class="hr-s">
            </md-layout>

            <md-layout md-gutter class="gutr">
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="15">
                <label>Date</label>
                <date-picker :format="selectDateFormat" lang="en" v-model="followModal.Date" id="Date"></date-picker>
                <span class="error" v-if="!followModal.Date">{{DateError}}</span>
              </md-layout>
            </md-layout>

            <md-layout md-gutter class="mrgtop-2per">
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="15">
                <md-layout md-flex="100">
                  <label>Select Truck</label>
                  <model-list-select
                    :list="showVehicleId"
                    v-model="followModal.selectTruck"
                    option-value="vehicleTruckId"
                    option-text="regdNo"
                    placeholder="Select Vehicle "
                  ></model-list-select>

                  <!-- <md-select name="movie" id="movie" v-model="followModal.selectTruck">
                    <md-option value>Select Truck</md-option>
                    <md-option
                      v-for="(obj1, index) in showVehicleId"
                      :key="index"
                      :value="obj1.vehicleTruckId"
                    >{{obj1.regdNo}}</md-option>
                  </md-select>-->
                </md-layout>
                <span class="error" v-if="!followModal.selectTruck">{{selectTruckError}}</span>
              </md-layout>

              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="20">
                <md-layout md-flex="100">
                  <label>From Location</label>
                  <model-list-select
                    :list="locationMasterList"
                    v-model="followModal.fromLocation"
                    option-value="pickupLocation"
                    option-text="pickupLocation"
                    placeholder="Select Location "
                  ></model-list-select>

                  <!-- <label>From Location</label>
                  <md-autocomplete
                    id="fromLocation"
                    name="fromLocation"
                    v-model="followModal.fromLocation"
                    :list="locationMasterList"
                    printAttribute="pickupLocation"
                    :filter-list="locationMasterFilter"
                  ></md-autocomplete>-->
                </md-layout>

                <span class="error" v-if="!followModal.fromLocation">{{fromLocationError}}</span>
              </md-layout>
              <md-layout md-flex="5"></md-layout>

              <md-layout md-flex="20">
                <md-layout md-flex="100">
                  <label>From Location</label>
                  <model-list-select
                    :list="locationMasterList"
                    v-model="followModal.toLocation"
                    option-value="pickupLocation"
                    option-text="pickupLocation"
                    placeholder="Select Location "
                  ></model-list-select>
                  <!-- <label>To Location</label>
                  <md-autocomplete
                    id="toLocation"
                    name="toLocation"
                    v-model="followModal.toLocation"
                    :list="locationMasterList"
                    printAttribute="pickupLocation"
                    :filter-list="locationMasterFilter"
                  ></md-autocomplete>-->
                </md-layout>
                <span class="error" v-if="!followModal.toLocation">{{toLocationError}}</span>
              </md-layout>

              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="20">
                <md-layout md-flex="100">
                  <label>Container No.</label>
                  <b-form-input :formatter="capitalizeAll"
                    id="containerNo"
                    name="containerNo"
                    v-model="followModal.containerNo"
                  ></b-form-input>
                </md-layout>
                <span class="error" v-if="!followModal.containerNo">{{containerNoError}}</span>
              </md-layout>
            </md-layout>

            <md-layout md-gutter class="gutr">
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="15">
                <md-layout md-flex="100">
                  <label>GRN No.</label>
                  <b-form-input :formatter="capitalizeAll" id="grnNo" name="grnNo" v-model="followModal.grnNo"></b-form-input>
                </md-layout>

                <span class="error" v-if="!followModal.grnNo">{{grnNoError}}</span>
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="20">
                <md-layout md-flex="100">
                  <label>Shipper Name</label>
                  <b-form-input :formatter="capitalizeAll"
                    id="shipperName"
                    name="shipperName"
                    v-model="followModal.shipperName"
                  ></b-form-input>
                </md-layout>
                <span class="error" v-if="!followModal.shipperName">{{shipperNameError}}</span>
              </md-layout>

              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="10">
                <md-layout md-flex="100">
                  <label>O.M.R.</label>
                  <b-form-input :formatter="capitalizeAll" id="omr" name="omr" v-model="followModal.omr"></b-form-input>
                </md-layout>
                <span class="error" v-if="!followModal.omr">{{omrError}}</span>
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="10">
                <md-layout md-flex="100">
                  <label>I.M.R.</label>
                  <b-form-input :formatter="capitalizeAll" id="imr" name="imr" v-model="followModal.imr"></b-form-input>
                </md-layout>

                <span class="error" v-if="!followModal.imr">{{imrError}}</span>
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="15">
                <md-layout md-flex="100">
                  <label>Kilometer Covered</label>
                  <b-form-input :formatter="capitalizeAll"
                    type="number"
                    min="0"
                    id="kmCovered"
                    name="kmCovered"
                    v-model="followModal.kmCovered"
                    @keyup="finalAmount()"
                  ></b-form-input>
                </md-layout>
                <span class="error" v-if="!followModal.kmCovered">{{kmCoveredError}}</span>
              </md-layout>
            </md-layout>
          </div>
          <!-- /.box-body -->
        </div>
      </md-dialog-content>

      <md-dialog-actions>
        <md-button class="md-primary" @click="addHireFollow">Ok</md-button>
      </md-dialog-actions>
    </md-dialog>

    <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="addPop"></md-dialog-alert>

    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      @close="onClose"
      ref="addPop1"
      style="z-index:9999999999"
    ></md-dialog-alert>
  </div>
</template>

<script>
import Vue from "vue";
import DatePicker from "vue2-datepicker";
import axios from "axios";
import { ModelListSelect } from "vue-search-select";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import moment from "moment";
import { URL_BASE, URL_BASE_DOC } from "../../../helper/constant.js";
import { DateFormat, selectDateFormat} from "../../../helper/filters";

export default {
  beforeMount() {
    // if (
    //   globalPermissionStatus("Transportation") &&
    //   this.$sessionsStorage.get("setContractId") != undefined &&
    //   this.$sessionsStorage.get("setContractId") != "" &&
    //   this.$sessionsStorage.get("clientId") != undefined &&
    //   this.$sessionsStorage.get("clientId") != ""
    // ) {
    //   this.$store.dispatch("setCurrentRoute", "/hireModalMaster/hireModal");
    //   console.log("uyuiyuiyui");
    //   this.getData();
    // } else {
    //   this.$router.push({
    //     path: "/sales/salesBooking"
    //   });
    // }

    if (
      this.$sessionsStorage.get("loginId") != undefined &&
      this.$sessionsStorage.get("loginId") != ""
    ) {
      if (
        this.$sessionsStorage.get("setContractId") != undefined &&
        this.$sessionsStorage.get("setContractId") != "" &&
        this.$sessionsStorage.get("clientId") != undefined &&
        this.$sessionsStorage.get("clientId") != ""
      ) {
        this.$store.dispatch("setCurrentRoute", "/hireModalMaster/hireModal");
        this.getData();
      } else {
        this.$router.push({
          path: "/sales/salesBooking"
        });
      }
    } else {
      this.$router.push({
        path: "/Login/"
      });
    }
  },

  data() {
    return {
      selectDateFormat,
      error: { vehicleSelectError: "", vehicleSelectError1: "" },
      emptyArray: [],
      newArray: {
        ids: []
      },
      alert: {
        content: "Added Succesfully",
        ok: "ok"
      },
      Vbooking: {
        hirevehiclebookingId: "",
        clientId: this.$sessionsStorage.get("clientId"),
        contractId: this.$sessionsStorage.get("setContractId"),
        noOfTrucks: ""
      },
      followModal: {
        hireFollowActivityId: "",
        clientId: this.$sessionsStorage.get("clientId"),
        contractId: this.$sessionsStorage.get("setContractId"),

        selectTruck: "",
        fromLocation: "",
        toLocation: "",
        Date: "",
        kmCovered: "",
        kmPending: "",
        finalCost: "",
        omr: "",
        imr: "",
        grnNo: "",
        containerNo: "",
        shipperName: ""
      },
      contractDetailModal: {
        contractId: "",
        clientId: "",
        fromValidity: "",
        toValidity: "",
        contractType: "",

        allowedKm: "",
        monthlyRent: "",
        overcharges: "",
        vehicleModal: "",
        vehicleType: "",
        grossWeight: "",
        noOfTrucks: ""
      },
      locationMaster: ["fdfd"],
      DateError: "",
      selectTruckError: "",
      fromLocationError: "",
      toLocationError: "",
      kmCoveredError: "",
      vehicleSelectError: "",
      vehicleSizeMaster: [{}],
      validateBookingForm: "",
      validateFollowForm: "",
      noOfTrucksError: "",
      isActiveFollowActivities: false,
      isActiveVehicleBooking: true,
      showVehicleId: [],
      showFollowUpActivity: [],
      omrError: "",
      imrError: "",
      grnNoError: "",
      containerNoError: "",
      shipperNameError: ""
    };
  },
  filters: {
    moment(date) {
      return DateFormat(date)
    }
  },

  mounted() {},

  beforeDestroy() {
    this.$store.dispatch("setSelectedArray", { selected: [] });
    this.$store.dispatch("setUnselectedArray", []);
    this.$store.dispatch("setFixArray", []);
  },

  destroyed() {},

  components: {
    DatePicker,
    ModelListSelect
  },

  computed: {
    checkIsDisabled() {
      return false;
    },
    locationMasterList() {
      return this.locationMaster;
    },
    unCheckItems() {
      this.JqueryFun();

      return this.$store.getters.getUnselectedArray;
    },
    checkItems() {
      this.JqueryFun();

      return this.$store.getters.getSelectedArray;
    }
  },

  methods: {
    viewClientpage() {
      this.$router.push({
        path: "/viewHireInvoice"
      });
    },
    locationMasterFilter(list, query) {
      return this.locationMaster.filter(x => {
        return x.pickupLocation.toLowerCase().includes(query.toLowerCase());
      });
    },
    closeModal() {
      this.$refs["dialog2"].close();
    },
    JqueryFun() {
      $("#hireModel1").DataTable();
      $("#hireModel2").DataTable();
      $("#hireModel3").DataTable();
    },
    onClose() {
      this.$refs["dialog2"].close();
      this.getData();
      this.JqueryFun();
    },
    hireSubmit() {
      this.$router.push({
        path: "/hireInvoice"
      });
    },

    validateVBooking() {
      let validate_new = true;

      if (this.Vbooking.noOfTrucks == "") {
        $("#noOfTrucks").focus();
        this.noOfTrucksError = "Enter no of truck";
        validate_new = false;
      }
      if (this.Vbooking.noOfTrucks != this.checkItems.length) {
        this.error.vehicleSelectError1 =
          "Please Select " + this.Vbooking.noOfTrucks + " trucks";
        validate_new = false;
      }

      if (validate_new != true) {
        this.validateBookingForm = false;
      } else {
        this.validateBookingForm = true;
      }
    },
    finalAmount() {
      if (this.contractDetailModal.contractType == "fuelType") {
        let vehicleMilage = 50;
        let dieselprice = 70;
        let overallPrice =
          (parseFloat(this.followModal.kmCovered) / parseFloat(vehicleMilage)) *
          parseFloat(dieselprice);
        let finalamount =
          parseFloat(this.contractDetailModal.monthlyRent) +
          parseFloat(overallPrice);

        this.followModal.finalCost = finalamount;
      } else {
        this.followModal.finalCost = this.contractDetailModal.monthlyRent;
      }
    },

    validateHireFollow() {
      let validate_new = true;

      if (this.followModal.kmCovered == "") {
        $("#kmCovered").focus();
        this.kmCoveredError = "Enter your kilometer";
        validate_new = false;
      }

      if (this.followModal.fromLocation == "") {
        $("#fromLocation").focus();
        this.fromLocationError = "Enter your Location";
        validate_new = false;
      }

      if (this.followModal.toLocation == "") {
        $("#toLocation").focus();
        this.toLocationError = "Enter your Location";
        validate_new = false;
      }

      if (this.followModal.selectTruck == "") {
        $("#noOfTrucks").focus();
        this.selectTruckError = "Please select truck";
        validate_new = false;
      }
      if (this.followModal.shipperName == "") {
        $("#shipperName").focus();
        this.shipperNameError = "Enter your shipper name";
        validate_new = false;
      }
      if (this.followModal.containerNo == "") {
        $("#containerNo").focus();
        this.containerNoError = "Enter your container no";
        validate_new = false;
      }
      if (this.followModal.grnNo == "") {
        $("#grnNo").focus();
        this.grnNoError = "Enter your grn number";
        validate_new = false;
      }
      if (this.followModal.imr == "") {
        $("#imr").focus();
        this.imrError = "Enter your I.M.R";
        validate_new = false;
      }
      if (this.followModal.omr == "") {
        $("#omr").focus();
        this.omrError = "Enter your O.M.R";
        validate_new = false;
      }

      if (validate_new != true) {
        this.validateFollowForm = false;
      } else {
        this.validateFollowForm = true;
      }
    },
    addHireFollow() {
      this.validateHireFollow();
      if (this.validateFollowForm != false) {
        this.followModal[
          "hirevehiclebookingId"
        ] = this.Vbooking.hirevehiclebookingId;

        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_TPTContract/addHireFollow.php`,
          data: JSON.stringify(this.followModal),

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId")
          }
        };
        axios(options)
          .then(result => {
            const { statusText, status, data } = result;
            if (result && data &&  status == 200) {
              if (data.msg == "Inserted Successfully") {
                this.alert.content = "Added Successfully";
              } else {
                this.alert.content = "Data Updated Successfully";
              }
              this.$refs["addPop1"].open();
            }
          })
          .catch(error => {});
      }
    },
    addVehicleBooking() {
      this.validateVBooking();
      if (this.validateBookingForm == true) {
        $("#addButtonLoader").css("display", "none");
        $("#loader").css("display", "block");
        this.Vbooking["vehicleTruckId"] = this.newArray.ids;

        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_TPTContract/addHireVehicleBooking.php`,
          data: JSON.stringify(this.Vbooking),

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId")
          }
        };
        axios(options)
          .then(result => {
            const { statusText, status, data } = result;
            if (result && data &&  status == 200) {
              this.$sessionsStorage.set(
                "hireVehicleBookingId",
                data.hirevehiclebookingId
              );
              this.Vbooking.hirevehiclebookingId = data.hirevehiclebookingId;
              if (data.msg == "Inserted Successfully") {
                this.alert.content = "Added Successfully";
              } else {
                this.alert.content = "Data Updated Successfully";
              }
              $("#addButtonLoader").css("display", "block");
              $("#loader").css("display", "none");
              this.$refs["addPop"].open();
              $("#followup").css("display", "block");
              if (this.isActiveVehicleBooking != false) {
                this.isActiveFollowActivities = true;
                (this.isActiveVehicleBooking = false), window.scrollTo(0, 0);
              }
            }
          })
          .catch(error => {});
      }
    },
    openAddTruckDialog() {
      if (this.Vbooking.noOfTrucks == "") {
        this.noOfTrucksError = "Enter no of truck";
      } else {
        this.$refs["dialog1"].open();
        this.JqueryFun();
      }
    },

    openSelectTruckDialog() {
      this.$refs["dialog2"].open();
      this.JqueryFun();
    },
    removeSelectedTruck(id, index, obj) {
      this.newArray.ids.splice(this.newArray.ids.indexOf(id), 1);

      setTimeout(() => this.$store.dispatch("setUnselectedArray", obj), 100);
    },
    checkSelectVehicle(index, obj) {
      if (this.newArray.ids.indexOf(obj.vehicleTruckId) < 0) {
        this.newArray.ids.push(obj.vehicleTruckId);
      } else if (this.newArray.ids.indexOf(obj.vehicleTruckId) > -1) {
        this.newArray.ids.splice(
          this.newArray.ids.indexOf(obj.vehicleTruckId),
          1
        );
      }

      if (this.newArray.ids.length > parseInt(this.Vbooking.noOfTrucks)) {
        this.newArray.ids.splice(
          this.newArray.ids.indexOf(obj.vehicleTruckId),
          1
        );

        this.error.vehicleSelectError =
          "Already Selected " + this.Vbooking.noOfTrucks + " Trucks";

        setTimeout(() => {
          Vue.set(this.emptyArray, index, false);
        }, 0);
        setTimeout(() => (this.error.vehicleSelectError = ""), 5000);
      }
    },
    onSubmitTable() {
      this.$store.dispatch("setSelectedArray", { selected: this.newArray.ids });
      this.emptyArray = Array(this.emptyArray.length).fill(false);
      this.JqueryFun();
      this.$refs["dialog1"].close();
    },
    getData() {
      let payload = {
        vehicleBook: "vehicle",
        clientId: this.$sessionsStorage.get("clientId"),
        contractId: this.$sessionsStorage.get("setContractId")
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_TPTContract/hireVehicleBooking.php`,
        data: JSON.stringify(payload),

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };
      axios(options)
        .then(result => {
          const { statusText, status, data } = result;
          if ( status == 200 && data) {
            this.$store.dispatch("setFixArray", data.truckMasterDetails);
            this.locationMaster = data.pickupLocationArray;

            Object.keys(data.contractDetails[0]).map(x => {
              this.contractDetailModal[x] = data.contractDetails[0][x] || "";
            });

            if (data.vehicleBooked.length > 0) {
              Object.keys(data.vehicleBooked[0]).map(x => {
                this.Vbooking[x] = data.vehicleBooked[0][x] || "";
                if (x == "vehicleTruckId") {
                  this.newArray.ids = data.vehicleBooked[0][x].split(",");
                  this.$store.dispatch(
                    "setSelectedBackendArray",
                    data.vehicleBooked[0][x].split(",")
                  );
                  this.onSubmitTable();

                  $("#followup").css("display", "block");
                  if (this.isActiveVehicleBooking != false) {
                    this.isActiveFollowActivities = true;
                    (this.isActiveVehicleBooking = false),
                      window.scrollTo(0, 0);
                  }
                }
              });
              if (data.vehicleMaster.length > 0) {
                this.showVehicleId = data.vehicleMaster;
              }
              if (data.vehicleFollow.length > 0) {
                this.showFollowUpActivity = data.vehicleFollow;
              }
              this.followModal.kmPending = data.pendingKm;
            }
            this.Vbooking.noOfTrucks = this.contractDetailModal.noOfTrucks;
            this.JqueryFun();
          }
        })
        .catch(err => {
          throw err;
        });
    }
  }
};
</script>
<style>
.md-direction-bottom-right {
  width: 20% !important;
}
.mrgtop-2per {
  margin-top: 3%;
}
.mrgtop-5px {
  margin-top: 0px;
}
.center {
  text-align: center;
}
.heght-1px {
  height: 1px;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}
.md-button-color {
  background-color: #607d8d !important;
}

.md-button-color-toggle {
  background-color: rgba(153, 153, 153, 0.4) !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}

.md-dialog-container.HereDialog.md-theme-default .md-dialog {
  width: 100%;
}
.md-select-content {
  z-index: 999999999;
}
</style>


// WEBPACK FOOTER //
// hireModel.vue?2b9a3006